import React, {useEffect} from "react";
import {Redirect, useLocation} from "react-router-dom";
import {PAGE_URLS} from "constants/AppConstants.js";
import {useAppUser} from "contexts/AppUserContext";
import OnboardingPage from "pages/OnboardingPage";
import SignInPage from "pages/SignInPage";
import {isOAuthCallbackQuery, oauthCallbackForwardUrl} from "utils/oauthCallbackForward";

/**
 * The web root. Signed-out visitors get the public landing page (Paddle approves a
 * checkout domain only from a page it can read without logging in). Any query or
 * hash still goes to the sign-in page: the Garmin, Suunto, Coros, Strava and
 * GPS-Speedsurfing OAuth redirects come back to the root with their code; one that
 * arrives signed out is sent on to the app's own origin (see oauthCallbackForward).
 */
function RootPage() {
  const {user, claims, isAuthenticating} = useAppUser();
  const {search, hash} = useLocation();

  const isCallback = isOAuthCallbackQuery(search);
  const forwardUrl =
    isCallback && !isAuthenticating
      ? oauthCallbackForwardUrl({
          currentUrl: window.location.href,
          appUrl: process.env.REACT_APP_APP_URL,
          redirectUri: process.env.REACT_APP_GARMIN_REDIRECT_URI,
          isSignedIn: !!user
        })
      : null;

  useEffect(() => {
    if (forwardUrl) window.location.replace(forwardUrl);
  }, [forwardUrl]);

  if (isCallback && (isAuthenticating || forwardUrl)) {
    return null;
  }
  if (search || hash) {
    return <SignInPage />;
  }
  if (user && claims) {
    return <Redirect to={PAGE_URLS.diaryPageUrl} />;
  }
  return <OnboardingPage />;
}

export default RootPage;
